module.exports = __webpack_public_path__ + "static/img/bg1.2f69d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/bg1.png
// module id = eQ6v
// module chunks = 70